module.exports = __webpack_public_path__ + "img/dice-logo3.e34b4394.svg";